module.exports = __webpack_public_path__ + "assets/images/scrolly-v2/tablet.svg?v=ca5b8870";